import React from 'react';
import { CheckIcon, XIcon, RepeatIcon } from 'lucide-react';
import { printAllowed, printNotAllowed } from '../data/content';
export function PrintRights() {
  return <section aria-labelledby="rights-title" className="bg-paper" data-id="element-198" data-mp="1mrt32ots6i47">
      <div className="mx-auto grid max-w-content gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[1fr_1.25fr] lg:items-center lg:py-24" data-id="element-199" data-mp="1hv2ippay10cz">
        <div data-id="element-200" data-mp="1dr4lxl93c1n3">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-leaf-wash text-leaf-deep" data-id="element-201" data-mp="2aiyfsv4fcuaa">
            <RepeatIcon className="h-6 w-6" aria-hidden="true" data-id="element-202" data-mp="25jlw2j8uo3bx" />
          </span>
          <h2 id="rights-title" className="mt-6 font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-203" data-mp="21iiglxups9b8">
            Print Again and Again
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-soft" data-id="element-204" data-mp="1wj5rt7ka8s60">
            Buy once, and print physical copies whenever you need them — for this Sunday, next month’s outreach, and every opportunity after.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2" data-id="element-205" data-mp="2lieynblvizqw">
          <div className="rounded-2xl bg-leaf-wash p-7" data-id="element-206" data-mp="2ljq0h5vrdxfd">
            <h3 className="font-extrabold text-navy" data-id="element-207" data-mp="2qi9p5e1qlnbf">Print physical copies for</h3>
            <ul className="mt-5 space-y-3" data-id="element-208" data-mp="2ciidvl2lul14">
              {printAllowed.map(a => <li key={a} className="flex items-center gap-3 font-semibold text-navy" data-id="element-209" data-mp="2hhbienzwz1p5">
                  <CheckIcon className="h-4 w-4 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-210" data-mp="2hj66ucae9bxz" />
                  {a}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl p-7 ring-1 ring-cream-line" data-id="element-211" data-mp="27l07o2fz2jwt">
            <h3 className="font-extrabold text-navy" data-id="element-212" data-mp="1ttburwxwfres">The digital files may not be</h3>
            <ul className="mt-5 space-y-3" data-id="element-213" data-mp="1xu5himzlv063">
              {printNotAllowed.map(n => <li key={n} className="flex items-center gap-3 font-semibold text-ink-soft" data-id="element-214" data-mp="1jumc41y6i2xh">
                  <XIcon className="h-4 w-4 shrink-0 text-coral" strokeWidth={3} aria-hidden="true" data-id="element-215" data-mp="1ormgm8fdqxmh" />
                  {n}
                </li>)}
            </ul>
          </div>
          <p className="text-sm leading-relaxed text-ink-mute sm:col-span-2" data-id="element-216" data-mp="3lqv4zze6rfz3">
            This is a personal, church and ministry printing license for the purchasing customer — not a resale license.
          </p>
        </div>
      </div>
    </section>;
}